import { isArchiveBattle, attachArchiveTitles } from '../../utils/historyArchive';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import Masonry from 'react-masonry-css';
import { useWebSocket } from '../../context/WebSocketContext';
import { useUser } from '../../context/UserContext';
import Message from '../../components/Message';
import { useTheme } from '../../context/ThemeContext';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import ReactDOM from 'react-dom'; // 添加ReactDOM导入

const PageWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: ${({ theme }) => theme.background};
  position: relative;
  overflow: visible; /* 改为visible确保不会裁剪内容 */

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:
      repeating-linear-gradient(
        45deg,
        ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)'} 0px,
        ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)'} 1px,
        transparent 1px,
        transparent 2px
      ),
      repeating-linear-gradient(
        -45deg,
        ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)'} 0px,
        ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)'} 1px,
        transparent 1px,
        transparent 2px
      ),
      linear-gradient(to bottom,
        ${({ theme }) => theme.cardBg},
        ${({ theme }) => theme.background}
      );
    pointer-events: none;
  }

  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
    opacity: ${({ theme }) => theme.isDark ? '0.08' : '0.12'};
    mix-blend-mode: ${({ theme }) => theme.isDark ? 'color-dodge' : 'multiply'};
    pointer-events: none;
  }
`;

const Container = styled.div`
  padding: 20px 24px 20px 24px;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  overflow: visible;
  
  @media (max-width: 1440px) {
    padding: 20px 24px;
  }
  
  @media (max-width: 1024px) {
    padding: 16px 20px;
  }
  
  @media (max-width: 768px) {
    padding: 12px 16px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 12px;
  }
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-bottom: ${props => props.$hasThreeImages ? '180px' : '60px'};
  align-items: flex-start;
  position: relative;
  padding-bottom: ${props => props.$hasThreeImages ? '0px' : '40px'};
  max-width: 100%;
  overflow: visible;
  
  @media (max-width: 1440px) {
    gap: 32px;
    margin-bottom: ${props => props.$hasThreeImages ? '160px' : '50px'};
  }
  
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 24px;
    padding-bottom: 0;
    margin-bottom: 40px;
  }
  
  @media (max-width: 768px) {
    gap: 20px;
    margin-bottom: 32px;
  }
  
  @media (max-width: 480px) {
    gap: 16px;
    margin-bottom: 24px;
  }
`;

const MainContent = styled.div`
  flex: 0 0 auto;
  width: 30%;
  min-width: 0;
  
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const WinnerImageSection = styled.div`
  flex: 1;
  overflow: visible;
  display: flex;
  justify-content: flex-end;
  max-width: calc(70% - 40px);
  padding-right: 0;
  box-sizing: border-box;
  
  @media (max-width: 1024px) {
    width: 100%;
    max-width: 100%;
    position: relative;
    left: auto;
    right: auto;
    top: auto;
  }
`;

const WinnerImagesWrapper = styled.div`
  width: 100%;
  overflow: visible;
  display: flex;
  justify-content: flex-end;
  position: relative;
`;

const WinnerImagesContainer = styled.div`
  display: flex;
  gap: 24px;
  width: auto;
  justify-content: flex-start;
  flex-wrap: nowrap;
  padding: 10px 0;
  overflow-x: auto;
  position: relative;
  
  ${props => props.$totalImages === 3 && `
    position: absolute;
    top: -20px;
    left: calc(100% - 3 * 371px - 2 * 24px);
    padding-right: 24px;
    box-sizing: border-box;
    width: auto;
  `}
  
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  @media (max-width: 1440px) {
    gap: 20px;
  }
  
  @media (max-width: 1024px) {
    justify-content: flex-start;
    margin-left: 0;
    gap: 16px;
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    
    & > * {
      scroll-snap-align: start;
    }
  }
  
  @media (max-width: 768px) {
    gap: 12px;
    padding: 5px 0;
  }
  
  @media (max-width: 480px) {
    gap: 8px;
    padding: 3px 0;
  }
`;

const WinnerImage = styled.img`
  width: auto;
  max-width: ${props => {
    switch(props.$totalImages) {
      case 1:
        return props.$isVertical ? '474px' : '764px';
      case 2:
        return '381px';
      case 3:
        return '371px';
      case 4:
        return '269.75px';
      case 5:
        return '211.1999969482422px';
      default:
        return '211.1999969482422px';
    }
  }};
  height: ${props => props.$totalImages === 4 ? '271.20416259765625px' : 'auto'};
  max-height: ${props => props.$totalImages === 4 ? '271.20416259765625px' : '430px'};
  border-radius: 0;
  object-fit: contain;
  object-position: center;
  background-color: transparent;
  
  @media (max-width: 1024px) {
    max-width: 280px;
  }
  
  @media (max-width: 768px) {
    max-width: 220px;
  }
`;

const WinnerTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const WinnerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ThemeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ThemeTitle = styled.h2`
  font-size: 18px;
  color: ${({ theme }) => theme.secondaryText};
  margin: 0;
  font-weight: 400;
`;

const ThemeContent = styled.h1`
  font-size: 28px;
  color: ${({ theme }) => theme.text};
  margin: 0;
  font-weight: 500;
  line-height: 1.3;

  @media (max-width: 1024px) {
    font-size: 24px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const WinnerTitle = styled.h2`
  font-size: 18px;
  color: ${({ theme }) => theme.secondaryText};
  margin: 0;
  font-weight: 400;
`;

const WinnerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const WinnerUser = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const WinnerUserRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const WinnerAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
`;

const WinnerName = styled.span`
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  font-weight: 500;
`;

const VoteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const VoteCount = styled.div`
  color: ${({ theme }) => theme.text};
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const VoterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const VoterAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
  cursor: pointer;
  transition: none;

  &:hover {
    transform: none;
  }

  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    border-width: 0;
  }
`;

const MoreVotersIndicator = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)'};
  color: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  border: none;
  box-shadow: none;
  transition: none;
  user-select: none;
  font-weight: 500;
  
  &:hover {
    transform: none;
    background-color: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.15)'};
  }
  
  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    font-size: 12px;
    border-width: 0;
  }
`;

const ExtendedVoterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  
  @media (max-width: 768px) {
    gap: 6px;
  }
`;

const VoterPopup = styled.div`
  position: fixed;
  background: ${({ theme }) => theme.cardBg || 'white'};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  width: 220px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  left: ${props => props.$position?.x || 0}px;
  top: ${props => props.$position?.y || 0}px;
  transform: translateX(-50%);
  
  @media (max-width: 768px) {
    width: 200px;
  }
`;

const VoterPopupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const VoterPopupAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
`;

const VoterPopupName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
`;

const VoterPopupInfo = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.secondaryText};
`;

const Section = styled.div`
  margin-top: ${props => props.$hasThreeImages ? '-50px' : '40px'};
  padding-top: ${props => props.$hasThreeImages ? '0px' : '0'};
  padding-right: 0;
  padding-left: 0;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    margin-top: 32px;
    padding-top: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  color: ${({ theme }) => theme.text};
  margin: 0 0 32px;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 0 24px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin: 0 0 20px;
  }
`;

const CreationGrid = styled(Masonry)`
  display: flex;
  width: auto;
  margin: 32px -12px 0;
  
  .masonry-grid_column {
    padding: 0 12px;
    background-clip: padding-box;
    
    > div {
      margin-bottom: 24px;
    }
  }

  @media (max-width: 1440px) {
    margin: 28px -10px 0;
    
    .masonry-grid_column {
      padding: 0 10px;
      
      > div {
        margin-bottom: 20px;
      }
    }
  }

  @media (max-width: 1024px) {
    margin: 24px -8px 0;
    
    .masonry-grid_column {
      padding: 0 8px;
      
      > div {
        margin-bottom: 16px;
      }
    }
  }
  
  @media (max-width: 768px) {
    margin: 20px -6px 0;
    
    .masonry-grid_column {
      padding: 0 6px;
      
      > div {
        margin-bottom: 12px;
      }
    }
  }

  @media (max-width: 480px) {
    margin: 16px -4px 0;
    
    .masonry-grid_column {
      padding: 0 4px;
      
      > div {
        margin-bottom: 8px;
      }
    }
  }
`;

const CreationCard = styled.div`
  background: transparent;
  overflow: visible;
  transition: none;
  margin-bottom: 24px;
  width: 100%;
  
  @media (max-width: 1024px) {
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 12px;
  }
  
    &:hover {
      transform: none;
  }
`;

const CreationImage = styled.img`
  width: 100%;
  aspect-ratio: 1.6;
  object-fit: contain;
  border-radius: 0;

  @media (max-width: 768px) {
    aspect-ratio: 1.4;
  }

  @media (max-width: 480px) {
    aspect-ratio: 1.2;
  }
`;

const CreationInfo = styled.div`
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  position: relative;
  z-index: 2;
  overflow: visible;
  
  @media (max-width: 768px) {
    padding: 12px 0;
  }
  
  @media (max-width: 480px) {
    padding: 8px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const RecommendButton = styled.button`
  position: absolute;
  top: 0;
  right: 16px;
  width: 24px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 11;
  background: ${({ $isRecommended }) => $isRecommended ? '#ff4d4f' : 'rgba(100, 100, 100, 0.6)'};
  backdrop-filter: ${({ $isRecommended }) => $isRecommended ? 'none' : 'blur(2px)'};
  border: none;
  padding: 0;
  opacity: 1;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 85%, 0 100%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  svg {
    width: 20px;
    height: 20px;
    color: ${({ $isRecommended }) => $isRecommended ? '#fff' : '#fff'};
    position: relative;
    margin-top: 2px;
  }

  &:hover {
    background: ${({ $isRecommended }) => $isRecommended ? '#ff7875' : 'rgba(120, 120, 120, 0.8)'};
    transform: translateY(2px);
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    gap: 8px;
    margin-bottom: 12px;
  }
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  box-shadow: none;

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

const Username = styled.span`
  color: ${({ theme }) => theme.text};
  font-size: 16px;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const VoteInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CreationWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;

  &:hover {
    ${RecommendButton}:not([data-always-visible='true']) {
      opacity: 1;
    }
  }
`;

const WinnerBadge = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 77, 79, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  backdrop-filter: blur(4px);
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.2);
`;

const UserCreations = styled.div`
  margin-top: 40px;
`;

const UserCreationsTitle = styled.h3`
  font-size: 18px;
  color: ${({ theme }) => theme.secondaryText};
  margin: 0 0 24px;
  font-weight: 400;
`;

const UserCreationsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
  }
`;

const UserCreationCard = styled(CreationCard)`
  min-width: 280px;
  width: 280px;
  border-radius: 0;
`;

const CreatorSection = styled.div`
  margin-top: 32px;
  border-top: 1px solid ${({ theme }) => theme.border};
  padding-top: 24px;

  @media (max-width: 768px) {
    margin-top: 24px;
    padding-top: 16px;
  }
`;

const CreatorTitle = styled.h3`
  font-size: 16px;
  color: ${({ theme }) => theme.secondaryText};
  margin: 0 0 16px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0 0 12px;
  }
`;

const RankedImagesSection = styled.div`
  margin-bottom: 40px;
  width: calc(100% + 48px);
  margin-left: -24px;
  box-sizing: border-box;
  
  .masonry-grid {
    display: flex;
    width: auto;
    flex-wrap: wrap;
  }

  .masonry-grid_column {
    background-clip: padding-box;
    padding-left: 24px;
    width: 25% !important; /* 强制每行四列 */
    
    @media (max-width: 1200px) {
      width: 33.333% !important;
    }
    
    @media (max-width: 900px) {
      width: 50% !important;
    }
    
    @media (max-width: 580px) {
      width: 100% !important;
    }
  }

  /* Style your items */
  .masonry-grid_column > div {
    margin-bottom: 16px;
  }
`;

const RankedImageItem = styled.div`
  width: 100%;
  break-inside: avoid;
  margin-bottom: 16px;
  transition: none;
  background: transparent;
  
  &:hover {
    transform: none;
  }
`;

const RankedImageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  margin-bottom: 8px;
`;

const RankNumber = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  min-width: 40px;
`;

const RankedImageContainer = styled.div`
  position: relative;
  width: 100%;
  display: block;
  overflow: visible;
  margin-bottom: 4px;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
`;

const RankedImageInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  background: transparent;
  margin-bottom: 4px;
  position: relative;
  z-index: 1;
  overflow: visible;
`;

const RankedImageVotes = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 20;
  
  &:hover {
    text-decoration: underline;
  }
`;

// 添加一个新的遮罩层样式
const DropdownOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: transparent;
  overscroll-behavior: contain; /* 防止滚动传播到父元素 */
  touch-action: none; /* 禁用默认的触摸行为 */
`;

// 修改VoterDropdown样式
const VoterDropdown = styled.div`
  background: ${({ theme }) => theme.cardBg || 'white'};
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
  width: 240px;
  max-height: 300px;
  overflow-y: auto;
  overscroll-behavior: contain; /* 防止滚动传播 */
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
    border-radius: 3px;
    
    &:hover {
      background: ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'};
    }
  }
  
  @media (max-width: 1024px) {
    width: 220px;
  }
  
  @media (max-width: 768px) {
    width: 200px;
    max-width: calc(100vw - 32px); /* 确保不超出屏幕 */
  }
  
  @media (max-width: 480px) {
    width: calc(100vw - 32px);
    max-height: 250px;
  }
`;

const VoterDropdownTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.secondaryText};
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
  
  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 6px;
    padding-bottom: 6px;
  }
`;

const RankedImageUser = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RankedImageAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
`;

const RankedImageUsername = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.text};
`;

const VoterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  
  &:not(:last-child) {
    margin-bottom: 2px;
  }
  
  @media (max-width: 480px) {
    gap: 6px;
    padding: 4px 0;
  }
`;

const VoterItemAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  box-shadow: none;
  
  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
  }
`;

const VoterItemName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.text};
  
  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const ActionButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;
  margin-bottom: 0;
  position: relative;
  gap: 16px;
`;

const ActionButton = styled.button`
  background: var(--brand, #FF4B3F);
  width: 238px;
  height: 72px;
  border-radius: 200px;
  padding: 7px 24px;
  gap: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 文字样式 */
  font-family: HanaMinA;
  font-weight: 500;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: white;
  white-space: nowrap;
  
  /* 确保文字在按钮中完全居中 */
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    filter: brightness(0.85);
    box-shadow: none;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const DownloadAllButton = styled.button`
  color: var(--brand, #FF4B3F);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  padding: 8px 0;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
  
  .download-icon {
    display: inline-flex;
    align-items: center;
  }
`;

const MultiWinnerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  margin-bottom: 20px;
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const MultiWinnerImage = styled(WinnerImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 1.6;
`;

const WinnerUserLabel = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const WinnerUserAvatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
`;

const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const FullScreenImage = styled.img`
  max-width: 95%;
  max-height: 95%;
  object-fit: contain;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 1001;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;

const CreationVotes = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 20;
  
  &:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  z-index: 1002;
  opacity: 0.5;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }
  
  &.prev {
    left: 20px;
  }
  
  &.next {
    right: 20px;
  }
`;

const ImageCounter = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 14px;
  z-index: 1002;
`;

const BattleDetail = () => {
  const { isDarkMode, theme } = useTheme();
  const { id } = useParams();
  const [battleData, setBattleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedVoter, setSelectedVoter] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [expandedVoterLists, setExpandedVoterLists] = useState({});
  const [openVoterDropdown, setOpenVoterDropdown] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [recommendedCreations, setRecommendedCreations] = useState(new Set());
  const navigate = useNavigate();
  const { isConnected, connect, resourceLimited, manualReconnectOnly, fightStatus } = useWebSocket();
  const { user } = useUser();
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allImages, setAllImages] = useState([]);
  const fullScreenWheelRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState(null); // 添加下拉菜单位置状态
  const [scrollY, setScrollY] = useState(0); // 添加滚动位置状态

  // 检查是否为管理员 - 尝试不同的字段
  useEffect(() => {
    const isAdminUser =
      user?.userType === 1 ||
      user?.type === 1 ||
      user?.role === 'admin' ||
      user?.isAdmin ||
      user?.admin;
    
    setIsAdmin(isAdminUser);
    console.log('是否管理员:', isAdminUser);
  }, [user]);

  // 修改 toggleVoterDropdown 函数
  const toggleVoterDropdown = (creationId, event) => {
    event.stopPropagation();
    event.preventDefault();
    
    // 如果当前下拉框已经打开，则关闭它
    if (openVoterDropdown === creationId) {
      setOpenVoterDropdown(null);
      setDropdownPosition(null);
      return;
    }
    
    // 获取触发元素的位置
    const triggerElement = event.currentTarget;
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      
      // 估计下拉菜单高度
      const dropdownHeight = 300; // 默认高度
      
      // 检查底部空间是否足够
      const isBottomSpaceLimited = rect.bottom + dropdownHeight > windowHeight - 20;
      
      // 设置位置
      let position = {};
      
      if (windowWidth < 768) {
        // 移动设备 - 在屏幕中间显示
        position = {
          position: 'fixed',
          top: 'auto',
          bottom: 'auto',
          left: '50%',
          transform: 'translateX(-50%)',
          width: windowWidth < 480 ? 'calc(100vw - 32px)' : '200px'
        };
        
        if (isBottomSpaceLimited) {
          // 如果触发元素在底部，将菜单放置在触发元素上方
          if (rect.top > windowHeight / 2) {
            position.bottom = (windowHeight - rect.top + 8) + 'px';
          } else {
            // 否则在中间位置
            position.top = Math.max(windowHeight * 0.2, 50) + 'px';
            position.maxHeight = (windowHeight * 0.6) + 'px';
          }
        } else {
          // 有足够空间，直接在触发元素下方
          position.top = (rect.bottom + 8) + 'px';
        }
      } else {
        // 桌面设备
        if (isBottomSpaceLimited) {
          position = {
            position: 'fixed',
            width: '240px'
          };
          
          // 是最后一行的长图
          if (rect.top > windowHeight * 0.7) {
            // 放在触发元素上方
            position.bottom = (windowHeight - rect.top + 8) + 'px';
            position.left = rect.left + 'px';
          } else if (rect.top < dropdownHeight + 40) {
            // 元素靠近顶部，放在下方
            position.top = Math.min(rect.bottom + 8, windowHeight * 0.2) + 'px';
            position.left = rect.left + 'px';
            position.maxHeight = (windowHeight * 0.7) + 'px';
          } else {
            // 中间位置的元素，放在上方
            position.bottom = (windowHeight - rect.top + 8) + 'px';
            position.left = rect.left + 'px';
          }
          
          // 检查是否靠近右边缘
          const rightEdgeDistance = windowWidth - rect.right;
          if (rightEdgeDistance < 240) {
            position.left = 'auto';
            position.right = (windowWidth - rect.right) + 'px';
          }
        } else {
          // 底部有足够空间
          position = {
            position: 'fixed',
            top: rect.bottom + 8 + 'px',
            left: rect.left + 'px'
          };
          
          // 检查是否靠近右边缘
          const rightEdgeDistance = windowWidth - rect.right;
          if (rightEdgeDistance < 240) {
            position.left = 'auto';
            position.right = (windowWidth - rect.right) + 'px';
          }
        }
      }
      
      // 保存位置信息
      setDropdownPosition(position);
    }
    
    // 设置打开状态
    setOpenVoterDropdown(creationId);
  };

  // 处理图片URL
  const processImageUrl = (url, isAvatar = false) => {
    // 如果是头像且没有URL或URL为空，直接返回空字符串
    if (!url && isAvatar) {
      return '';
    }
    
    // 检查URL是否为空或undefined
    if (!url) return '';
    
    // 如果是base64数据，直接返回
    if (url.startsWith('data:')) {
      return url;
    }
    
    // 如果是头像且URL已经是https://static.battleverse.cn/userpic/格式，直接返回
    if (isAvatar && url.includes('https://static.battleverse.cn/userpic/')) {
      return url;
    }
    
    // 如果是头像且是其他完整URL，直接返回
    if (isAvatar && (url.startsWith('http://') || url.startsWith('https://'))) {
      return url;
    }
    
    // 如果是头像且只是数字，如 "1.png"
    if (isAvatar && /^\d+(\.\w+)?$/.test(url)) {
      return `https://static.battleverse.cn/userpic/${url}`;
    }
    
    // 如果是头像且包含avatars路径，转换为userpic路径
    if (isAvatar && (url.includes('avatars/') || url.startsWith('/avatars/'))) {
      const avatarName = url.split('avatars/')[1];
      return `https://static.battleverse.cn/userpic/${avatarName}`;
    }
    
    // 如果是头像且包含userpic路径但缺少域名
    if (isAvatar && (url.includes('userpic/') || url.startsWith('/userpic/'))) {
      const avatarName = url.split('userpic/')[1];
      return `https://static.battleverse.cn/userpic/${avatarName}`;
    }
    
    // 如果是头像且是其他情况
    if (isAvatar) {
      return `https://static.battleverse.cn/userpic/${url}`;
    }
    
    // 以下是非头像图片的处理逻辑
    
    // 如果是绝对URL，直接返回
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    
    // 如果是带/前缀的相对路径
    if (url.startsWith('/')) {
      return `https://static.battleverse.cn${url}`;
    }
    
    // 其他情况，添加基础URL
    return `https://static.battleverse.cn/${url}`;
  };

  useEffect(() => {
    const fetchBattleDetail = async () => {
      let loadingMessageId;
      try {
        setLoading(true);
        loadingMessageId = Message.loading('加载中...', 0);
        
        const response = await axios.post('//server.battleverse.cn/index/fight/item.do', {
          fightId: id
        }, {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        });
        
        if (!response.data.success) {
          throw new Error(response.data.msg || '获取对战详情失败');
        }

        const battleData = await attachArchiveTitles(response.data.data);
        
        // 按照票数从高到低排序获胜者列表
        if (battleData.winnerList && battleData.winnerList.length > 0) {
          battleData.winnerList.sort((a, b) => {
            const aVotes = a.voteNumber || (a.voteList ? a.voteList.length : 0);
            const bVotes = b.voteNumber || (b.voteList ? b.voteList.length : 0);
            return bVotes - aVotes;
          });
        }
        
        setBattleData(battleData);
        
        if (isAdmin) {
          fetchRecommendedStatus();
        }
      } catch (error) {
        console.error('获取对战详情失败:', error);
        Message.error('获取对战详情失败');
      } finally {
        setLoading(false);
        Message.destroy(loadingMessageId);
      }
    };

    fetchBattleDetail();
  }, [id, isAdmin, user.token]);

  // 获取推荐状态
  const fetchRecommendedStatus = async () => {
    try {
      const recommendedSet = new Set();
      const localRecommendedIds = localStorage.getItem('recommendedCreations');
      if (localRecommendedIds) {
        const ids = JSON.parse(localRecommendedIds);
        ids.forEach(id => recommendedSet.add(parseInt(id)));
      }
      setRecommendedCreations(recommendedSet);
    } catch (error) {
      console.error('获取推荐状态失败:', error);
      Message.error('获取推荐状态失败');
    }
  };

  // 检查WebSocket连接状态
  useEffect(() => {
    // 只有在非手动模式下才尝试自动重连
    if (!manualReconnectOnly) {
      const interval = setInterval(() => {
        // 只有在连接断开且资源不受限的情况下才尝试重连
        if (!isConnected && !resourceLimited) {
          console.log('BattleDetail页面检测到WebSocket连接断开，尝试重新连接...');
          connect();
        }
      }, 60000); // 每60秒检查一次
      
      return () => clearInterval(interval);
    }
  }, [isConnected, connect, resourceLimited, manualReconnectOnly]);

  // 处理推荐/取消推荐
  const handleRecommend = async (creationId, currentRecommended) => {
    try {
      const response = await axios.post(
        '//server.battleverse.cn/admin/creation/recommend.do',
        {
          creationId: parseInt(creationId),
          recommend: currentRecommended ? 0 : 1
        },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        setRecommendedCreations(prev => {
          const newSet = new Set(prev);
          if (currentRecommended) {
            newSet.delete(creationId);
          } else {
            newSet.add(creationId);
          }
          return newSet;
        });
        
        const updatedRecommended = Array.from(
          currentRecommended
            ? new Set([...recommendedCreations].filter(id => id !== creationId))
            : new Set([...recommendedCreations, creationId])
        );
        localStorage.setItem('recommendedCreations', JSON.stringify(updatedRecommended));
        
        Message.success(response.data.msg || '操作成功');
      } else {
        Message.error(response.data.msg || '操作失败');
      }
    } catch (error) {
      console.error('推荐操作失败:', error);
      Message.error(error.response?.data?.msg || '操作失败，请重试');
    }
  };

  // 处理设置下轮对战
  const handleSetupNextBattle = () => {
    navigate('/battle-settings');
  };

  // 处理参加下轮对战
  const handleJoinNextBattle = () => {
    navigate('/battle');
  };

  // 判断是否有下轮对战
  const hasNextBattle = fightStatus && fightStatus > 0;

  // 处理投票者头像点击
  const handleVoterClick = (voter, event) => {
    event.stopPropagation();
    
    // 如果已经选中该投票者，则关闭弹窗
    if (selectedVoter && selectedVoter.userId === voter.userId) {
      setSelectedVoter(null);
      return;
    }
    
    // 设置弹窗位置
    const rect = event.target.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    
    // 计算弹窗位置，避免超出屏幕
    let x = rect.left + rect.width / 2;
    const y = rect.bottom + 10;
    
    // 弹窗的预估宽度
    const popupWidth = 220;
    
    // 确保弹窗不会超出左侧或右侧边界
    if (x - (popupWidth / 2) < 10) {
      // 靠近左边缘时
      x = popupWidth / 2 + 10;
    } else if (x + (popupWidth / 2) > windowWidth - 10) {
      // 靠近右边缘时
      x = windowWidth - (popupWidth / 2) - 10;
    }
    
    setPopupPosition({ x, y });
    setSelectedVoter(voter);
  };

  const toggleVoterList = (winnerId) => {
    setExpandedVoterLists(prev => ({
      ...prev,
      [winnerId]: !prev[winnerId]
    }));
  };
  
  // 渲染投票者列表
  const renderVoterList = (winner) => {
    if (!winner.voteList || winner.voteList.length === 0) return null;
    
    const isExpanded = !!expandedVoterLists[winner.id];
    const displayCount = 5; // 默认显示5个头像
    
    if (winner.voteList.length <= displayCount) {
      // 如果投票人数不超过显示数量，直接全部显示
      return (
        <VoterList>
          {winner.voteList.map((voter, index) => (
            <VoterAvatar
              key={index}
              src={processImageUrl(voter.userPic, true)}
              alt={voter.userName}
              title={voter.userName}
              onClick={(e) => handleVoterClick(voter, e)}
            />
          ))}
        </VoterList>
      );
    } else {
      // 如果投票人数超过显示数量，根据展开状态决定显示方式
      return (
        <>
          <VoterList>
            {/* 始终显示前displayCount个头像 */}
            {winner.voteList.slice(0, displayCount).map((voter, index) => (
              <VoterAvatar
                key={index}
                src={processImageUrl(voter.userPic, true)}
                alt={voter.userName}
                title={voter.userName}
                onClick={(e) => handleVoterClick(voter, e)}
              />
            ))}
            {/* 添加更多指示器 */}
            <MoreVotersIndicator
              onClick={() => toggleVoterList(winner.id)}
              title={isExpanded ? "收起" : `还有${winner.voteList.length - displayCount}人`}
            >
              {isExpanded ? "-" : `+${winner.voteList.length - displayCount}`}
            </MoreVotersIndicator>
          </VoterList>
          
          {/* 展开时显示剩余的投票者 */}
          {isExpanded && (
            <ExtendedVoterList>
              {winner.voteList.slice(displayCount).map((voter, index) => (
                <VoterAvatar
                  key={index}
                  src={processImageUrl(voter.userPic, true)}
                  alt={voter.userName}
                  title={voter.userName}
                  onClick={(e) => handleVoterClick(voter, e)}
                />
              ))}
            </ExtendedVoterList>
          )}
        </>
      );
    }
  };

  // Define breakpoints for the masonry grid
  const breakpointColumnsObj = {
    default: 4, // 强制4列
    1200: 3,    // 3 columns at 1200px
    900: 2,     // 2 columns at 900px
    580: 1      // 1 column at 580px
  };

  // 添加处理图片点击全屏显示的函数
  const handleImageClick = (imageUrl) => {
    // 首先收集所有图片
    const images = [];
    
    // 添加获胜者图片
    if (battleData.winnerList && battleData.winnerList.length > 0) {
      battleData.winnerList.forEach(winner => {
        if (winner.creationUrl) {
          images.push(processImageUrl(winner.creationUrl));
        }
      });
    }
    
    // 添加其他作品
    const creationList = Array.isArray(battleData.creationList) ?
      battleData.creationList :
      (battleData.creationList ? [battleData.creationList] : []);
    
    creationList.forEach(creation => {
      if (creation.creationUrl) {
        images.push(processImageUrl(creation.creationUrl));
      }
    });
    
    // 去重
    const uniqueImages = [...new Set(images)];
    setAllImages(uniqueImages);
    
    // 找到当前图片在集合中的索引
    const index = uniqueImages.findIndex(img => img === imageUrl);
    setCurrentImageIndex(index >= 0 ? index : 0);
    setFullScreenImage(imageUrl);
  };

  // 关闭全屏显示
  const closeFullScreen = (e) => {
    setFullScreenImage(null);
  };

  // 切换到上一张图片
  const goToPrevImage = useCallback(() => {
    if (allImages.length <= 1) return;
    
    const newIndex = (currentImageIndex - 1 + allImages.length) % allImages.length;
    setCurrentImageIndex(newIndex);
    setFullScreenImage(allImages[newIndex]);
  }, [allImages, currentImageIndex]);

  // 切换到下一张图片
  const goToNextImage = useCallback(() => {
    if (allImages.length <= 1) return;
    
    const newIndex = (currentImageIndex + 1) % allImages.length;
    setCurrentImageIndex(newIndex);
    setFullScreenImage(allImages[newIndex]);
  }, [allImages, currentImageIndex]);

  // 处理鼠标滚轮事件
  const handleWheel = useCallback((e) => {
    if (!fullScreenImage) return;
    
    e.preventDefault();
    
    // 向下滚动 deltaY > 0，向上滚动 deltaY < 0
    if (e.deltaY > 0) {
      goToNextImage();
    } else {
      goToPrevImage();
    }
  }, [fullScreenImage, goToNextImage, goToPrevImage]);

  // 添加键盘和滚轮事件监听
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (fullScreenImage) {
        if (e.key === 'Escape') {
          setFullScreenImage(null);
        } else if (e.key === 'ArrowRight') {
          goToNextImage();
        } else if (e.key === 'ArrowLeft') {
          goToPrevImage();
        }
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    // 添加鼠标滚轮事件监听器
    const wheelTarget = fullScreenWheelRef.current;
    if (wheelTarget) {
      wheelTarget.addEventListener('wheel', handleWheel, { passive: false });
    }
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      
      if (wheelTarget) {
        wheelTarget.removeEventListener('wheel', handleWheel);
      }
    };
  }, [fullScreenImage, goToNextImage, goToPrevImage, handleWheel]);

  // 添加下载图片功能
  const handleDownloadImages = async () => {
    try {
      // Show loading message
      const loadingMsgId = Message.loading('正在准备下载图片...', null, 0);
      
      // Collect all unique images from the battle
      const allImages = [];
      const seenUrls = new Set();
      
      // Function to safely add an image to our collection
      const addImage = (creation, prefix = '') => {
        if (creation && creation.creationUrl) {
          const url = processImageUrl(creation.creationUrl);
          // Skip duplicates by URL
          if (!seenUrls.has(url)) {
            seenUrls.add(url);
            const userName = creation.userName || 'unknown';
            const creationId = creation.id || creation.creationId || Date.now();
            allImages.push({
              url: url,
              fileName: `${prefix}${userName}_${creationId}.png`,
              element: document.querySelector(`img[src="${url}"]`) // Try to get the DOM element
            });
          }
        }
      };
      
      // Add winner images with "winner_" prefix
      if (battleData.winnerList && battleData.winnerList.length > 0) {
        battleData.winnerList.forEach(winner => addImage(winner, 'winner_'));
      }
      
      // Add other participant images
      const creationList = Array.isArray(battleData.creationList) ?
        battleData.creationList :
        (battleData.creationList ? [battleData.creationList] : []);
      
      creationList.forEach(creation => addImage(creation, 'entry_'));
      
      if (allImages.length === 0) {
        Message.destroy(loadingMsgId);
        Message.error('没有找到可下载的图片');
        return;
      }
      
      // Create ZIP
      const zip = new JSZip();
      const folder = zip.folder(`battle_images_${id || 'unknown'}`);
      
      // Update loading message
      Message.destroy(loadingMsgId);
      const progressMsgId = Message.loading(`准备下载 (0/${allImages.length})...`, null, 0);
      
      let successCount = 0;
      let failCount = 0;
      
      // Download each image
      for (let i = 0; i < allImages.length; i++) {
        const image = allImages[i];
        
        // Update progress message
        Message.destroy(progressMsgId);
        const currentMsgId = Message.loading(`下载图片 (${i+1}/${allImages.length})...`, null, 0);
        
        // Try to get image from DOM first (already loaded images)
        if (image.element) {
          try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = image.element.naturalWidth || image.element.width;
            canvas.height = image.element.naturalHeight || image.element.height;
            
            // Draw the image to canvas
            ctx.drawImage(image.element, 0, 0);
            
            // Convert to blob
            const blob = await new Promise(resolve => {
              canvas.toBlob(resolve, 'image/png');
            });
            
            if (blob) {
              folder.file(image.fileName, blob);
              successCount++;
              Message.destroy(currentMsgId);
              continue; // Skip to next image
            }
          } catch (canvasError) {
            console.warn('Canvas extraction failed, falling back to fetch:', canvasError);
            // Continue to fetch methods below
          }
        }
        
        // Try direct fetch with proxy
        try {
          const proxyUrl = `https://images.weserv.nl/?url=${encodeURIComponent(image.url)}`;
          const response = await fetch(proxyUrl);
          
          if (!response.ok) {
            throw new Error(`代理请求失败: ${response.status}`);
          }
          
          const blob = await response.blob();
          folder.file(image.fileName, blob);
          successCount++;
        } catch (error) {
          console.error(`下载图片失败: ${image.url}`, error);
          
          // Try backup proxy
          try {
            const backupProxyUrl = `https://corsproxy.io/?${encodeURIComponent(image.url)}`;
            const backupResponse = await fetch(backupProxyUrl);
            
            if (!backupResponse.ok) {
              throw new Error(`备用代理请求失败: ${backupResponse.status}`);
            }
            
            const blob = await backupResponse.blob();
            folder.file(image.fileName, blob);
            successCount++;
          } catch (backupError) {
            console.error(`备用代理也失败: ${image.url}`, backupError);
            failCount++;
            
            // Add failure record with original URL
            folder.file(
              `${image.fileName}.failed.txt`,
              `无法下载此图片。原始链接:\n${image.url}`
            );
          }
        }
        
        // Close progress message
        Message.destroy(currentMsgId);
      }
      
      // Add README file
      const readmeTxt =
        `# 对战图片 - ${battleData.fightNameCn || battleData.fightName || '未知主题'}\n\n` +
        `总共${allImages.length}张图片，成功下载${successCount}张，${failCount}张下载失败。\n\n` +
        `下载时间: ${new Date().toLocaleString()}\n`;
      
      folder.file('README.txt', readmeTxt);
      
      // Generate and download ZIP file
      const zipMsgId = Message.loading('正在生成ZIP文件...', null, 0);
      const content = await zip.generateAsync({type: 'blob'});
      saveAs(content, `battle_images_${id || 'unknown'}.zip`);
      
      // Show result
      Message.destroy(zipMsgId);
      
      if (successCount > 0) {
        if (failCount > 0) {
          Message.success(`已下载 ${successCount}/${allImages.length} 张图片，${failCount}张下载失败`);
        } else {
          Message.success(`已成功下载全部 ${allImages.length} 张图片！`);
        }
      } else {
        Message.error('无法下载图片，请尝试其他方法');
      }
    } catch (error) {
      console.error('打包图片时发生错误:', error);
      Message.destroy();
      Message.error('下载失败，请重试');
    }
  };

  // 创建一个单独的下拉菜单渲染函数
  const renderDropdownContent = (creation) => {
    if (!creation) return null;
    
    const hasVotes = creation.voteList && creation.voteList.length > 0;
    
    return (
      <VoterDropdown className="voter-dropdown" onClick={(e) => e.stopPropagation()}>
        <VoterDropdownTitle>投票者列表</VoterDropdownTitle>
        {!hasVotes ? (
          <VoterItem>
            <span>暂无投票</span>
          </VoterItem>
        ) : (
          creation.voteList.map((voter, index) => (
            <VoterItem key={index}>
              <VoterItemAvatar
                src={processImageUrl(voter.userPic, true)}
                alt={voter.userName}
              />
              <VoterItemName>{voter.userName}</VoterItemName>
            </VoterItem>
          ))
        )}
      </VoterDropdown>
    );
  };

  // 创建一个单独的触摸移动处理函数，供下拉菜单使用
  const handleDropdownTouchMove = (e) => {
    // 如果滚动发生在下拉菜单内部，则阻止事件传播
    if (e.target.closest('.voter-dropdown')) {
      // 只阻止传播，不阻止默认行为，这样菜单内部可以滚动
      e.stopPropagation();
    } else {
      // 如果不是在菜单内部，阻止默认行为防止页面滚动
      e.preventDefault();
    }
  };

  // 控制body滚动锁定的effect
  useEffect(() => {
    if (openVoterDropdown) {
      // 存储原始的body样式
      const originalStyle = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        touchAction: document.body.style.touchAction
      };
      
      // 禁用body滚动
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'relative';
      document.body.style.touchAction = 'none';
      
      // 组件卸载或下拉菜单关闭时恢复原始样式
      return () => {
        document.body.style.overflow = originalStyle.overflow;
        document.body.style.position = originalStyle.position;
        document.body.style.touchAction = originalStyle.touchAction;
      };
    }
  }, [openVoterDropdown]);

  // 为renderVoterDropdown添加自动关闭功能
  const renderVoterDropdown = () => {
    if (!openVoterDropdown || !dropdownPosition) return null;
    
    // 找到当前打开的creation
    const allCreations = getSortedCreations();
    const openCreation = allCreations.find(creation =>
      (creation.id === openVoterDropdown || creation.creationId === openVoterDropdown)
    );
    
    if (!openCreation) return null;
    
    // 使用Portal将下拉菜单渲染到body
    return ReactDOM.createPortal(
      <DropdownOverlay
        onClick={() => {
          setOpenVoterDropdown(null);
          setDropdownPosition(null);
        }}
        onWheel={(e) => {
          // 检测到鼠标滚轮滚动时关闭菜单
          if (!e.target.closest('.voter-dropdown') && Math.abs(e.deltaY) > 10) {
            setOpenVoterDropdown(null);
            setDropdownPosition(null);
          }
        }}
        onTouchMove={handleDropdownTouchMove}
      >
        <div
          style={{
            ...dropdownPosition,
            zIndex: 10000
          }}
          onClick={e => e.stopPropagation()}
          className="voter-dropdown-container"
        >
          {renderDropdownContent(openCreation)}
        </div>
      </DropdownOverlay>,
      document.body
    );
  };

  // 添加合并和排序所有作品的函数
  const getSortedCreations = useCallback(() => {
    if (!battleData) return [];
    
    // 合并列表
    const allCreations = [
      ...(battleData.winnerList || []),
      ...(Array.isArray(battleData.creationList) ? battleData.creationList : [])
    ];
    
    // 去重 - 因为winnerList中的作品可能也在creationList中
    const uniqueCreations = [];
    const seenIds = new Set();
    
    allCreations.forEach(creation => {
      if (creation && creation.id && !seenIds.has(creation.id)) {
        seenIds.add(creation.id);
        uniqueCreations.push(creation);
      } else if (creation && creation.creationId && !seenIds.has(creation.creationId)) {
        // 某些情况下，id字段可能不存在，但creationId存在
        seenIds.add(creation.creationId);
        uniqueCreations.push(creation);
      }
    });
    
    // 按得票数排序，从高到低
    return uniqueCreations.sort((a, b) => {
      // 获取a的票数
      const aVotes = a.voteList ? a.voteList.length : (a.voteNumber || 0);
      // 获取b的票数
      const bVotes = b.voteList ? b.voteList.length : (b.voteNumber || 0);
      
      // 从高到低排序
      if (bVotes !== aVotes) {
        return bVotes - aVotes;
      }
      
      // 如果票数相同，按创建时间排序（较新的在前）
      if (a.createTime && b.createTime) {
        return new Date(b.createTime) - new Date(a.createTime);
      }
      
      // 如果时间也相同或不存在，按ID排序
      const aId = a.id || a.creationId || 0;
      const bId = b.id || b.creationId || 0;
      return aId - bId;
    });
  }, [battleData]);

  // 修改点击事件处理
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 检查点击是否在下拉框或触发按钮之外
      if (
        openVoterDropdown &&
        !event.target.closest('.voter-dropdown') &&
        !event.target.closest('.voter-count') &&
        !event.target.closest('.voter-dropdown-container')
      ) {
        setOpenVoterDropdown(null);
        setDropdownPosition(null);
      }
    };
    
    // 添加滚动事件监听，滚动时关闭下拉菜单
    const handleScroll = () => {
      // 获取当前滚动位置
      const currentScrollY = window.scrollY;
      
      // 如果滚动距离超过阈值且下拉菜单已打开，直接关闭菜单
      if (openVoterDropdown && Math.abs(currentScrollY - scrollY) > 10) {
        setOpenVoterDropdown(null);
        setDropdownPosition(null);
      }
      
      // 更新滚动位置
      setScrollY(currentScrollY);
    };
    
    // 添加 resize 事件监听，窗口大小改变时关闭下拉菜单
    const handleResize = () => {
      if (openVoterDropdown) {
        setOpenVoterDropdown(null);
        setDropdownPosition(null);
      }
    };
    
    // 添加触摸处理
    let startY = 0;
    let startX = 0;
    
    const handleTouchStart = (e) => {
      // 只记录起始点，不执行任何操作
      startY = e.touches[0].clientY;
      startX = e.touches[0].clientX;
    };
    
    // 触摸移动处理函数 - 只在不是菜单内部时关闭
    const handleTouchMove = (e) => {
      if (!openVoterDropdown) return;
      
      // 如果是在菜单内部的滑动，允许其正常进行
      if (e.target.closest('.voter-dropdown') || e.target.closest('.voter-dropdown-container')) {
        return;
      }
      
      const touchY = e.touches[0].clientY;
      const touchX = e.touches[0].clientX;
      
      // 计算移动距离
      const diffY = Math.abs(touchY - startY);
      const diffX = Math.abs(touchX - startX);
      
      // 如果是有效的滑动距离，则关闭菜单
      if (diffY > 20 || diffX > 20) {
        setOpenVoterDropdown(null);
        setDropdownPosition(null);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    
    // 初始化滚动位置
    setScrollY(window.scrollY);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, [openVoterDropdown, scrollY]);

  if (loading) {
    return (
      <PageWrapper>
        <Container style={{ display: 'flex', justifyContent: 'center', padding: '80px 0 0' }}>
          <div style={{
            minWidth: '160px',
            padding: '10px 24px',
            borderRadius: '100px',
            background: 'rgba(0, 0, 0, 0.85)',
            color: 'white',
            fontWeight: '500',
            fontSize: '14px',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(8px)'
          }}>
            <span style={{
              display: 'inline-block',
              width: '14px',
              height: '14px',
              marginRight: '8px',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '50%',
              borderTopColor: '#fff',
              animation: 'spin 1s linear infinite',
              verticalAlign: 'middle'
            }}></span>
            加载中...
            <style>{`              @keyframes spin {
                to {
                  transform: rotate(360deg);
                }
              }
            `}</style>
          </div>
        </Container>
      </PageWrapper>
    );
  }

  if (!battleData) {
    return <Container>未找到对战数据</Container>;
  }

  return (
    <PageWrapper>
      {/* 添加全屏图片显示 */}
      {fullScreenImage && (
        <FullScreenOverlay
          onClick={closeFullScreen}
          ref={fullScreenWheelRef}
        >
          <CloseButton onClick={closeFullScreen}>×</CloseButton>
          
          {/* 添加导航按钮 */}
          <NavigationButton
            className="prev"
            onClick={(e) => {
              e.stopPropagation();
              goToPrevImage();
            }}
          >
            &#10094;
          </NavigationButton>
          
          <FullScreenImage
            src={fullScreenImage}
            alt="全屏图片"
            onClick={(e) => e.stopPropagation()}
          />
          
          <NavigationButton
            className="next"
            onClick={(e) => {
              e.stopPropagation();
              goToNextImage();
            }}
          >
            &#10095;
          </NavigationButton>
          
          {/* 添加图片计数器 */}
          <ImageCounter>
            {currentImageIndex + 1} / {allImages.length}
          </ImageCounter>
        </FullScreenOverlay>
      )}
      
      {/* 渲染下拉菜单 */}
      {renderVoterDropdown()}
      
      <Container>
        <TopSection $hasThreeImages={battleData.winnerList.length === 3}>
          <MainContent>
            <Header>
              <ThemeSection>
                <ThemeTitle>主题</ThemeTitle>
                <ThemeContent>{battleData.fightNameCn || battleData.fightName}</ThemeContent>
                {isArchiveBattle(battleData) && <p style={{color: "var(--text-secondary)", fontSize: 14, lineHeight: 1.7}}>{battleData.fightDesc}</p>}
              </ThemeSection>
              
              <WinnerTextSection>
                <WinnerSection>
                  <WinnerTitle>{isArchiveBattle(battleData) ? '获奖者' : '获胜者'}</WinnerTitle>
                  {battleData.winnerList.length > 0 && (
                    <WinnerInfo>
                      <WinnerUserRow>
                        {battleData.winnerList.map((winner, index) => (
                          <WinnerUser key={index}>
                            <WinnerAvatar
                              src={processImageUrl(winner.userPic, true)}
                              alt={winner.userName}
                            />
                            <WinnerName>{winner.userName}</WinnerName>
                          </WinnerUser>
                        ))}
                      </WinnerUserRow>
                    </WinnerInfo>
                  )}
                  
                  {/* 管理员按钮或参加下轮按钮 */}
                  {isAdmin ? (
                    <ActionButtonContainer>
                      <ActionButton onClick={handleSetupNextBattle}>
                        设置下轮
                      </ActionButton>
                      <DownloadAllButton onClick={handleDownloadImages}>
                        下载本局所有图片
                        <div className="download-icon">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M8 2v8M8 10l-3-3M8 10l3-3"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </DownloadAllButton>
                    </ActionButtonContainer>
                  ) : hasNextBattle ? (
                    <ActionButtonContainer>
                      <ActionButton onClick={handleJoinNextBattle}>
                        参加下轮
                      </ActionButton>
                    </ActionButtonContainer>
                  ) : null}
                </WinnerSection>
              </WinnerTextSection>
            </Header>
          </MainContent>
          <WinnerImageSection>
            <WinnerImagesWrapper>
              <WinnerImagesContainer $totalImages={battleData.winnerList.length}>
                {battleData.winnerList.map((winner, index) => {
                  // 检查图片是否为纵向
                  const img = new Image();
                  img.src = winner.creationUrl;
                  const isVertical = img.height > img.width;

                  // 根据获胜者数量决定最大宽度
                  const maxWidth = (() => {
                    const count = battleData.winnerList.length;
                    if (count === 1) return '320px';
                    if (count === 2) return '280px';
                    if (count === 3) return '371px';
                    return '180px'; // 4张或更多
                  })();

                  // 如果是3张图，添加特殊样式
                  const style = {
                    cursor: 'pointer',
                    objectFit: 'contain',
                    maxWidth: maxWidth,
                    height: 'auto'
                  };

                  if (battleData.winnerList.length === 3) {
                    style.height = '373px';
                  }
                  
                  // 如果是4张图，添加特定高度
                  if (battleData.winnerList.length === 4) {
                    style.height = '271.20416259765625px';
                    style.maxWidth = '269.75px';
                  }

                  return (
                    <WinnerImage
                      key={index}
                      src={processImageUrl(winner.creationUrl)}
                      alt={`${winner.userName}的作品`}
                      loading="lazy"
                      onClick={() => handleImageClick(processImageUrl(winner.creationUrl))}
                      style={style}
                    />
                  );
                })}
              </WinnerImagesContainer>
            </WinnerImagesWrapper>
          </WinnerImageSection>
        </TopSection>

        {/* 投票者弹窗 */}
        {selectedVoter && (
          <VoterPopup $position={popupPosition} onClick={(e) => e.stopPropagation()}>
            <VoterPopupHeader>
              <VoterPopupAvatar
                src={processImageUrl(selectedVoter.userPic, true)}
                alt={selectedVoter.userName}
              />
              <VoterPopupName>{selectedVoter.userName}</VoterPopupName>
            </VoterPopupHeader>
          </VoterPopup>
        )}

        <Section $hasThreeImages={battleData.winnerList.length === 3}>
          {/* 调试信息 */}
          <div style={{ display: 'none' }}>
            <p>battleData存在: {battleData ? '是' : '否'}</p>
            <p>creationList存在: {battleData && battleData.creationList ? '是' : '否'}</p>
            <p>creationList类型: {battleData && battleData.creationList ? (Array.isArray(battleData.creationList) ? '数组' : '对象') : '未知'}</p>
            <p>creationList长度: {battleData && battleData.creationList && Array.isArray(battleData.creationList) ? battleData.creationList.length : '未知'}</p>
          </div>
          
          <RankedImagesSection>
            {battleData && (
              <div style={{ paddingRight: '24px' }}>
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="masonry-grid"
                  columnClassName="masonry-grid_column"
                >
                  {/* 所有作品按照票数从高到低排序展示 */}
                  {getSortedCreations().map((creation, index) => (
                    <RankedImageItem key={`creation-${creation.id || creation.creationId || index}`}>
                      <RankedImageContainer>
                        <img
                          src={processImageUrl(creation.creationUrl)}
                          alt={`作品 ${index + 1}`}
                          loading="lazy"
                          onClick={() => handleImageClick(processImageUrl(creation.creationUrl))}
                          style={{
                            cursor: 'pointer',
                            objectFit: 'contain'
                          }}
                        />
                        {isAdmin && (
                          <RecommendButton
                            $isRecommended={recommendedCreations.has(creation.creationId)}
                            $alwaysVisible={true}
                            data-always-visible="true"
                            onClick={() => handleRecommend(
                              creation.creationId,
                              recommendedCreations.has(creation.creationId)
                            )}
                          >
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              {recommendedCreations.has(creation.creationId) ? (
                                <path
                                  d="M6 12L10 16L18 8"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              ) : (
                                <path
                                  d="M12 6V18M6 12H18"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              )}
                            </svg>
                          </RecommendButton>
                        )}
                      </RankedImageContainer>
                      
                      {creation.archiveTitle && <p style={{margin: "12px 0 4px", fontWeight: 600}}>{creation.archiveTitle}</p>}
                      <RankedImageInfo>
                        <RankedImageUser>
                          <RankedImageAvatar
                            src={processImageUrl(creation.userPic, true)}
                            alt={creation.userName}
                          />
                          <RankedImageUsername>{creation.userName}</RankedImageUsername>
                        </RankedImageUser>
                        
                        <RankedImageVotes
                          className="voter-count"
                          onClick={isArchiveBattle(battleData) ? undefined : (e) => toggleVoterDropdown(creation.id || creation.creationId, e)}
                          data-id={creation.id || creation.creationId}
                        >
                          {isArchiveBattle(battleData) ? '票数未记录' : `${creation.voteList && creation.voteList.length > 0 ? creation.voteList.length : creation.voteNumber || 0} 票`}
                        </RankedImageVotes>
                      </RankedImageInfo>
                    </RankedImageItem>
                  ))}
                </Masonry>
              </div>
            )}
          </RankedImagesSection>
        </Section>
      </Container>
    </PageWrapper>
  );
};

export default BattleDetail;
